import type { ReactNode } from "react";

interface ContentContainerProps {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
}

export const ContentContainer = ({
  children,
  title,
  subtitle,
}: ContentContainerProps) => (
  <div className="mx-auto w-full max-w-[450px]">
    {(title || subtitle) && (
      <div className="mb-8">
        {title && (
          <h1 className="text-primary-900 text-4xl font-bold">{title}</h1>
        )}
        {subtitle && <p className="text-secondary-600 mt-2">{subtitle}</p>}
      </div>
    )}
    {children}
  </div>
);
